<template>
    <div class="transition"></div>
</template>

<script>

    export default {
        name: 'Home',
        components: {}
    }
</script>

<style scoped lang="scss">
    .transition {
        min-height: 100vh;
    }
</style>
